import { makeStyles, tokens } from '@fluentui/react-components';
import { useLocation } from 'react-router-dom';
import { PRODUCT_NAME } from '../../branding';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${tokens.spacingHorizontalXXL}`,
    height: '56px',
    backgroundColor: 'white',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground3,
  },
  breadcrumbSeparator: {
    color: tokens.colorNeutralForeground4,
  },
  breadcrumbCurrent: {
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
});

// One entry per rail item. Keep in step with Sidebar.tsx and App.tsx.
const routeTitles: Record<string, string> = {
  '/deploy': 'Deploy',
  '/deployments': 'Deployments',
  '/products': 'Products',
  '/settings': 'Settings',
};

export function Header() {
  const styles = useStyles();
  const location = useLocation();

  const pathKey = location.pathname.split('/').slice(0, 2).join('/') || '/';
  const title = routeTitles[pathKey];

  return (
    <header className={styles.header}>
      <nav className={styles.breadcrumb} aria-label="Breadcrumb">
        <span>{PRODUCT_NAME}</span>
        {title && (
          <>
            <span className={styles.breadcrumbSeparator}>/</span>
            <span className={styles.breadcrumbCurrent}>{title}</span>
          </>
        )}
      </nav>
    </header>
  );
}
